import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51515254"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "home__item home__info" }
const _hoisted_3 = {
  key: 0,
  class: "home__item home__form"
}
const _hoisted_4 = {
  key: 0,
  class: "form--login"
}
const _hoisted_5 = {
  key: 0,
  class: "form--register"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_l_info_home = _resolveComponent("l-info-home")!
  const _component_l_login_form = _resolveComponent("l-login-form")!
  const _component_l_register_form = _resolveComponent("l-register-form")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_l_info_home)
    ]),
    (!_ctx.isLogin)
      ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
          _createVNode(_Transition, { name: "list" }, {
            default: _withCtx(() => [
              (_ctx.switchLogin)
                ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
                    _createVNode(_component_l_login_form)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "list1" }, {
            default: _withCtx(() => [
              (!_ctx.switchLogin)
                ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
                    _createVNode(_component_l_register_form)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}